"use client"

import { TelnyxRTCProvider } from "@telnyx/react-client"
import { useState } from "react"

import TelnyxReactSDK from "./TelnyxReactSDK"

export default function TelnyxSDK({ callInfo, loginCredential, setCallInfo }) {
  const [credential, setCredential] = useState({
    // login_token: loginCredential,
    password: loginCredential?.password,
    login: loginCredential?.username,
    ringtoneFile: "/audios/file_example_MP3_700KB.mp3"
    // ringbackFile: '/audios/file_example_MP3_700KB.mp3',
  })
  
  return (
    <TelnyxRTCProvider credential={credential}>
      <TelnyxReactSDK callInfo={callInfo} setCallInfo={setCallInfo} />
    </TelnyxRTCProvider>
  )
}
